import { createSlice } from '@reduxjs/toolkit';
import { getList, getListDataApi, getListViewsApi } from '../server/lists';

const initialActiveListState = {
    activeList: {
        _id: '',
        name: '',
        type: '',
        color: '',
        icon: '',
        creator: '',
        defaultViewId: '',
        data: [],
        views: [],
        columns: [],
        fileManagerObject: {},
        subLists: []
    },
    activeView: {
        _id: '',
        name: '',
        type: '',
        columns: []
    },
    limit: 500,
    currentPage: 1,
    totalPages: 0,
    totalItems: 0
}

const activeListSlice = createSlice({
    name: 'activeList',
    initialState: initialActiveListState,
    reducers: {
        resetActiveList(state) {
            state.activeList = {
                _id: '',
                name: '',
                type: '',
                color: '',
                icon: '',
                creator: '',
                defaultViewId: '',
                data: [],
                views: [],
                columns: [],
                fileManagerObject: {},
                subLists: []
            }
        },
        updateActiveList(state, actions) {
            state.activeList = actions.payload;
        },
        updateActiveListViews(state, actions) {
            state.activeList.views = actions.payload;
        },
        updateActiveListData(state, actions) {
            state.activeList.data = actions.payload;
        },
        updateActiveListDataRowById(state, actions) {
            const rowIndex = state.activeList.data.findIndex(r => r._id === actions.payload._id);
            if (rowIndex >= 0) {
                state.activeList.data[rowIndex][actions.payload.property] = actions.payload.value;
            }
        },
        updateActiveListProperty(state, actions) {
            state.activeList[actions.payload.property] = actions.payload.value;
        },
        // addRowToActiveList(state, actions) {
        //     const row = actions.payload.row;
        //     state.activeList.data.push(row);
        // },
        // updateRowToActiveList(state, actions) {
        //     const rowId = actions.payload.rowId;
        //     const row = actions.payload.row;
        //     if (rowId && row) {
        //         const rowIndex = state.activeList.data.findIndex((r) => r._id === rowId);
        //         if (rowIndex >= 0) {
        //             state.activeList.data[rowIndex] = row;
        //         }
        //     }
        // },

        resetActiveView(state) {
            state.activeView = {
                _id: '',
                name: '',
                type: '',
                columns: []
            }
        },
        updateActiveView(state, actions) {
            state.activeView = actions.payload;
        },
        updateActiveViewColumns(state, actions) {
            state.activeView.columns = actions.payload;

            const viewIndex = state.activeList.views.findIndex((v) => v._id.toString() === state.activeView._id);
            if (viewIndex >= 0) {
                state.activeList.views[viewIndex].columns = actions.payload;
            }
        },
        // updateActiveListViewProperty(state, actions) {
        //     const viewId = actions.payload.viewId;
        //     const property = actions.payload.property;
        //     const value = actions.payload.value;

        //     const viewIndex = state.activeList.views.findIndex((v) => v._id.toString() === viewId);
        //     if (viewIndex >= 0) {
        //         const updatedView = JSON.parse(JSON.stringify(state.activeList.views[viewIndex]));
        //         updatedView[property] = value;
        //         state.activeList.views[viewIndex] = updatedView;
        //     }
        // },
        // updateActiveViewProperty(state, actions) {
        //     const property = actions.payload.property;
        //     const value = actions.payload.value;

        //     const updatedView = JSON.parse(JSON.stringify(state.activeView));
        //     updatedView[property] = value;
        //     state.activeView = updatedView;
        // },
        resetCurrentPage(state) { state.currentPage = 1; },
        resetTotalPages(state) { state.totalPages = 0; },
        resetTotalItems(state) { state.totalItems = 0; },
        updateCurrentPage(state, actions) { state.currentPage = actions.payload; },
        updateTotalPages(state, actions) { state.totalPages = actions.payload; },
        updateTotalItems(state, actions) { state.totalItems = actions.payload; },
    }
});

export const activeListActions = activeListSlice.actions;
export default activeListSlice;

export const fetchActiveListById = (listId, viewId, page = 1, limit = 500) => {
    return async (dispatch) => {
        dispatch(activeListActions.resetActiveList());
        dispatch(activeListActions.resetActiveView());
        dispatch(activeListActions.resetCurrentPage());
        dispatch(activeListActions.resetTotalPages());
        dispatch(activeListActions.resetTotalItems());

        try {
            // const resList = await getList(listId, page, limit);
            // const resData = await getListDataApi(listId, viewId, page, limit);

            // const list = resList.list;
            // if (list) {
            //     list.views = resList.views || [];
            //     list.subLists = resList.subLists || [];
            //     list.data = resData.data || [];
            //     dispatch(activeListActions.updateActiveList(list));
            // }
            // dispatch(activeListActions.updateCurrentPage(resData.currentPage));
            // dispatch(activeListActions.updateTotalPages(resData.totalPages));
            // dispatch(activeListActions.updateTotalItems(resData.totalItems));

            const resList = await getList(listId, viewId, page, limit);

            const list = resList.list;
            if (list) {
                list.views = resList.views || [];
                list.subLists = resList.subLists || [];
                list.data = resList.data || [];
                dispatch(activeListActions.updateActiveList(list));
            }
            dispatch(activeListActions.updateCurrentPage(resList.currentPage));
            dispatch(activeListActions.updateTotalPages(resList.totalPages));
            dispatch(activeListActions.updateTotalItems(resList.totalItems));
        } catch (err) {
            // window.location.href = '/sys';
            console.log('catch error: ', err);
        }
    }
}

export const fetchActiveListViewsById = (listId, viewId) => {
    return async (dispatch) => {
        try {
            const res = await getListViewsApi(listId);
            const views = res.views || [];
            dispatch(activeListActions.updateActiveListViews(views));
            if (views.find(v => v._id === viewId)) {
                dispatch(activeListActions.updateActiveView(views.find(v => v._id === viewId)));
            } else {
                dispatch(activeListActions.resetActiveView());
            }
        } catch (err) {
            console.log('catch error: ', err);
        }
    }
}

export const fetchActiveListDataById = (listId, viewId, page = 1, limit = 500) => {
    return async (dispatch) => {
        try {
            const res = await getListDataApi(listId, viewId, page, limit);
            dispatch(activeListActions.updateActiveListData(res.data || []));
            dispatch(activeListActions.updateCurrentPage(res.currentPage));
            dispatch(activeListActions.updateTotalPages(res.totalPages));
            dispatch(activeListActions.updateTotalItems(res.totalItems));
        } catch (err) {
            console.log('catch error: ', err);
        }
    }
}